export default __webpack_public_path__ + "static/media/Landing1.2eeee1c8.png";